import { render, staticRenderFns } from "./noAccess.vue?vue&type=template&id=3f5bd50e&scoped=true&"
import script from "./noAccess.vue?vue&type=script&lang=ts&"
export * from "./noAccess.vue?vue&type=script&lang=ts&"
import style0 from "./noAccess.vue?vue&type=style&index=0&id=3f5bd50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5bd50e",
  null
  
)

component.options.__file = "noAccess.vue"
export default component.exports